export const AgentBannerContent = (
    <div className='text-2xl'>
      Join Our Team of Licensed Agents
    </div>
  )